"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalBackgroundStyled = exports.ModalWrapperStyled = exports.BodyOverflowStyled = void 0;

var _utils = require("../../utils");

var _helpers = require("../../const/helpers");

var _templateObject, _templateObject2, _templateObject3;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var BodyOverflowStyled = (0, _utils.createGlobalStyle)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  body {\n    overflow: hidden;\n  }\n"])));
exports.BodyOverflowStyled = BodyOverflowStyled;
var ModalWrapperStyled = (0, _utils.styled)('div')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: fixed;\n  overflow-y: auto;\n  padding: ", " 0;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1000;\n  display: block;\n  ", "\n  ", "\n"])), function (_ref) {
  var measure = _ref.measure;
  return measure === 'full' ? '0' : '50px';
}, function (_ref2) {
  var backdrop = _ref2.backdrop;
  return backdrop && 'background: rgba(0, 0, 0, 0.6);';
}, function (props) {
  return (0, _helpers.spacingStyle)(props);
});
exports.ModalWrapperStyled = ModalWrapperStyled;
var ModalBackgroundStyled = (0, _utils.styled)('div')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: block;\n"])));
exports.ModalBackgroundStyled = ModalBackgroundStyled;